import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Route, RouteProps, Redirect, useLocation, useHistory } from 'react-router-dom';
import RootStore, { ROOT_STORE } from 'src/stores/rootStore';

interface IProtectedRouterInjectedProps {
  [ROOT_STORE]: RootStore;
}

const ProtectedRouter: React.FC<RouteProps> = inject(ROOT_STORE)(observer((props) => {
  const { component: Component, ...rest } = props;
  const { rootStore: { authenticateStore, userStore } } = props as IProtectedRouterInjectedProps;

  if (Component === undefined) {
    throw new Error();
  }

  const location = useLocation();
  const history = useHistory();

  React.useEffect(() => {
    console.log('checkUserStatus');

    if (Component !== undefined) {
      if (authenticateStore.isAuthenticated) {
        console.log('isAuthenticated');
        checkUserStatus();
      } else {
        console.log('isNotAuthenticated');
      }
    }
  }, [authenticateStore.isAuthenticated, location.pathname]);

  const checkUserStatus = async () => {
    try {
      if (!userStore.fetchUserAsync.pending){
        await userStore.fetchUserAsync();
      }

      if (userStore.fetchUserAsync.resolved) {
        if(!userStore.userIsActive) {
          // console.log('userIsActive is false');
          await authenticateStore.signOut();
          setTimeout(() => {
            history.push('/login');
          }, 300);
        } else {
          // console.log('userIsActive is true');
        }
      }
    } catch (error) {
      console.error('checkUserStatus', error);
    }
  };

  return (
    <Route {...rest} render={ props$ => (
      authenticateStore.isAuthenticated
        ? <Component {...props$} />
        : <Redirect to='/login' />
    )} />
  );
}));

export default ProtectedRouter;


// WEBPACK FOOTER //
// ./src/modules/protectedRouter.tsx